/*
  NORGE home · the ring (sections/norge-home-ring.liquid, styles in assets/norge-home-ring.css).

  Lays the product items out on an ellipse and turns the ring: drag or flick (pixels become
  angle; a flick carries on, then the ring settles on the nearest product), a sideways trackpad
  scroll (vertical scrolling stays with the page), the arrows, the keyboard arrows, or a tap on a
  side product. Every settle marks the front product: its card is shown, the dots and the count
  follow. Reduced motion: no easing, the ring jumps.

  Mounts on every [data-nring] on the page and on the theme editor's section reloads.
*/
(function () {
  "use strict";
  function mount(root) {
    if (root.nringMounted) return;
    var ring = root.querySelector("[data-nring-ring]"), items = [].slice.call(root.querySelectorAll("[data-nring-item]"));
    var cards = [].slice.call(root.querySelectorAll("[data-nring-card]")), dots = root.querySelector("[data-nring-dots]"), count = root.querySelector("[data-nring-count]");
    if (!ring || items.length < 2) { if (cards[0]) cards[0].classList.add("is-on"); return; }
    root.nringMounted = true;
    // the theme's header is fixed over the top of the page: give the hero the rest of the screen
    var bars = document.querySelectorAll("header, .header-section, [data-header]"), bar = 0;
    for (var k = 0; k < bars.length; k++) {
      var cs = getComputedStyle(bars[k]), rb = bars[k].getBoundingClientRect();
      if ((cs.position === "fixed" || cs.position === "sticky") && rb.height > 0 && rb.height < 200) bar = Math.max(bar, Math.round(rb.height));
    }
    root.style.setProperty("--nring-bar", bar + "px");
    var N = items.length, STEP = Math.PI * 2 / N;
    var reduce = window.matchMedia && matchMedia("(prefers-reduced-motion: reduce)").matches;
    var rot = 0, target = 0, vel = 0, raf = 0, front = -1, dragged = false;

    function pad(i) { return String(i).padStart(2, "0"); }
    function show(i) {
      cards.forEach(function (c, k) { c.classList.toggle("is-on", k === i); });
      if (dots) [].forEach.call(dots.children, function (d, k) { d.classList.toggle("is-on", k === i); });
      if (count) count.textContent = pad(i + 1) + " / " + pad(N);
    }
    function layout() {                          // item i sits at angle i*STEP - rot; 0 is the front
      var W = ring.clientWidth, I = items[0].clientWidth, R = Math.min(W * .4, 460), best = -2, bi = 0;
      var SPAN = I * .42, SC0 = .36;              // the ellipse's height (back items rise this far) and the back scale
      items.forEach(function (el, i) {
        var th = i * STEP - rot, s = Math.sin(th), c = Math.cos(th), d = (c + 1) / 2;   // d: 1 front .. 0 back
        var x = s * R, y = -(1 - d) * SPAN, sc = SC0 + (1 - SC0) * Math.pow(d, 1.25);
        el.style.transform = "translate3d(" + x.toFixed(1) + "px," + y.toFixed(1) + "px,0) scale(" + sc.toFixed(3) + ")";
        el.style.opacity = (.45 + .55 * Math.pow(d, 1.2)).toFixed(3);
        el.style.zIndex = String(Math.round(d * 100));
        var img = el.querySelector("img"), tag = el.querySelector(".nring-tag");
        if (img) img.style.filter = "drop-shadow(0 30px 34px rgba(24,24,24," + (.1 + .16 * d).toFixed(2) + "))" + (d > .985 ? "" : " blur(" + ((1 - d) * 1.8).toFixed(2) + "px)");
        if (tag) {                               // labels stay the same size at every depth; none behind the front item
          tag.style.transform = "translateX(-50%) scale(" + (1 / sc).toFixed(3) + ")";
          tag.style.visibility = (d < .9 && Math.abs(x) < I * .5) ? "hidden" : "";
        }
        if (c > best) { best = c; bi = i; }
      });
      items.forEach(function (el, i) { el.classList.toggle("is-side", i !== bi); });
      if (bi !== front) { front = bi; show(bi); }
    }
    function tick() {
      raf = 0;
      var diff = target - rot;
      if (Math.abs(diff) < .0005) { rot = target; layout(); return; }
      rot += reduce ? diff : diff * .14;
      layout(); raf = requestAnimationFrame(tick);
    }
    function kick() { if (!raf) raf = requestAnimationFrame(tick); }
    function snap() { target = Math.round(target / STEP) * STEP; kick(); }
    function go(i) {                             // the short way round to item i
      var want = i * STEP, k = Math.round((target - want) / (Math.PI * 2));
      target = want + k * Math.PI * 2; kick();
    }
    function stepBy(n) { target = Math.round(target / STEP) * STEP + n * STEP; kick(); }

    items.forEach(function (el, i) { el.addEventListener("click", function () { if (!dragged) go(i); }); });
    [].forEach.call(root.querySelectorAll("[data-nring-step]"), function (b) {
      b.addEventListener("click", function () { stepBy(parseInt(b.getAttribute("data-nring-step"), 10) || 1); });
    });
    root.addEventListener("keydown", function (e) {
      if (e.key === "ArrowRight") { stepBy(1); e.preventDefault(); }
      if (e.key === "ArrowLeft") { stepBy(-1); e.preventDefault(); }
    });
    if (!root.hasAttribute("tabindex")) root.setAttribute("tabindex", "-1");

    // drag / flick: pixels -> angle, momentum, then a snap
    var px0 = 0, r0 = 0, lastX = 0, lastT = 0, down = false;
    ring.addEventListener("pointerdown", function (e) {
      if (e.target.closest("[data-nring-step]")) return;
      down = true; dragged = false; px0 = lastX = e.clientX; r0 = target = rot; vel = 0; lastT = performance.now();
      ring.classList.add("is-drag");
      try { ring.setPointerCapture(e.pointerId); } catch (x) {}
    });
    ring.addEventListener("pointermove", function (e) {
      if (!down) return;
      var W = ring.clientWidth, dx = e.clientX - px0;
      if (Math.abs(dx) > 4) dragged = true;
      rot = r0 - dx / W * Math.PI * 1.1; target = rot;
      var now = performance.now(); vel = (e.clientX - lastX) / Math.max(1, now - lastT); lastX = e.clientX; lastT = now;
      layout();
    });
    function up() {
      if (!down) return;
      down = false; ring.classList.remove("is-drag");
      var W = ring.clientWidth;
      target = rot - vel * 220 / W * Math.PI * 1.1;   // carry the flick on, then settle on a product
      snap(); setTimeout(function () { dragged = false; }, 50);
    }
    ring.addEventListener("pointerup", up); ring.addEventListener("pointercancel", up);
    // trackpad: a sideways scroll turns the ring one product at a time
    var acc = 0, accT = 0;
    ring.addEventListener("wheel", function (e) {
      if (Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return;
      e.preventDefault(); acc += e.deltaX;
      if (Math.abs(acc) > 60) { stepBy(acc > 0 ? 1 : -1); acc = 0; }
      clearTimeout(accT); accT = setTimeout(function () { acc = 0; }, 200);
    }, { passive: false });
    window.addEventListener("resize", layout, { passive: true });
    if (window.ResizeObserver) new ResizeObserver(layout).observe(ring);
    layout(); show(front < 0 ? 0 : front);
    root.nringRing = { go: go, step: stepBy };
  }
  function boot() { [].forEach.call(document.querySelectorAll("[data-nring]"), mount); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot); else boot();
  document.addEventListener("shopify:section:load", function (e) {
    if (e.target) [].forEach.call(e.target.querySelectorAll("[data-nring]"), mount);
  });
})();
